var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Modal from "../../UI/Modal/Modal";
import { ModalCloseButton } from "../../UI/StandardButtons/StandardButtons";
import useService from "../../Hooks/useService";
import TermBasedSuccesScoringService from "../../../Services/TermBasedSuccessScoring.service";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
import ModalHeader from "../../UI/Modal/ModalHeader";
import SuccessScoringTable from "../SuccessScoring/SuccessScoringTable";
const TermBasedSuccessScoringModal = (_a) => {
    var { affiliationId, studentName } = _a, modalProps = __rest(_a, ["affiliationId", "studentName"]);
    const [reasonsState, loadReasons] = useService(TermBasedSuccesScoringService.getScoreReasons);
    React.useEffect(() => {
        if (modalProps.isOpen) {
            loadReasons(affiliationId);
        }
    }, [affiliationId, loadReasons, modalProps.isOpen]);
    return (_jsxs(Modal, Object.assign({}, modalProps, { children: [_jsx(ModalHeader, { title: "Term Persistence Success Measures", closeModal: modalProps.onModalClosed }), _jsxs("div", { className: "modal-body", children: [_jsx("h4", { className: "mb-3", children: studentName }), _jsx(ServiceResult, { state: reasonsState, errorMessage: "There was an error loading the success reasons for this student", children: (reasons) => _jsx(SuccessScoringTable, { scoring: reasons }) })] }), _jsx("div", { className: "modal-footer", children: _jsx(ModalCloseButton, { onClick: modalProps.onModalClosed }) })] })));
};
export default TermBasedSuccessScoringModal;
